import styles from './ChatBubble.module.css';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

export default function ChatBubble({
  message,
  side = 'left',
  type = 'default',
}) {
  const isRight = side === 'right';
  const isError = type === 'error';
  console.log('isError', isError);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className={`${styles.bubbleWrapper} ${
        isRight ? styles.right : styles.left
      }`}
    >
      <div
        className={`
          ${styles.bubble}
          ${isError ? styles.bubbleError : ''}
          ${isRight ? styles.bubbleRight : styles.bubbleLeft}
          
          ${visible ? styles.animateIn : styles.hidden}
        `}
      >
        {isError && <span className={styles.errorIcon}>⚠️</span>}
        {message}
      </div>
    </div>
  );
}

ChatBubble.propTypes = {
  message: PropTypes.string.isRequired,
  side: PropTypes.oneOf(['left', 'right']),
  type: PropTypes.oneOf(['default', 'error']),
};
